<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="location-maps">
<h1>Location Maps</h1>
<p style="text-align:center"><img alt="" src="media/file0.png" style="width:4.30555in;height:6.48667in"/></p>
<p style="text-align: center;"><em>Map of the Pyrenees © Steve Cracknell</em></p>
<p style="text-align:center"><img alt="" src="media/file1.jpg" style="width:4.025in;height:5.845in"/></p>
<p style="text-align: center;"><em>Detailed map of study area—for location see previous page Data from</em></p>
<p style="text-align: center;"><em>©OpenStreetMap</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?3c07bbba